<app-page-header [title]="'Samples'" [subtitle]="'Manage samples for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <div class="flex gap-4 items-center">
            <p-ifta-label>
                <p-iconfield>
                    <p-inputicon class="pi pi-search"/>
                    <input pInputText id="on_label" [(ngModel)]="this.search" autocomplete="off"
                           (input)="onSearchInputChange()">
                </p-iconfield>
                <label for="on_label">Search samples</label>
            </p-ifta-label>
            <span class="relative inline-block">
        <p-button
                (click)="displayFilterDialog()"
                icon="pi pi-filter"
                label="Filter"
                severity="secondary"
                text
        ></p-button>
                @if (hasActiveFilters()) {
                    <span
                            class="absolute top-1 right-1 h-2 w-2 rounded-full bg-red-500"
                    ></span>
                }
      </span>
        </div>
        <p-button isMaintainer [hidden]="false" label="Add Sample" icon="pi pi-plus"
                  (click)="this.openCreateSampleDialog()"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm overflow-x-auto">
        <p-table
                [value]="this.samples"
                [tableStyle]="{'min-width': '75rem'}"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [loading]="this.loading"
                [first]="this.currentPage * this.rows"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th class="w-20 min-w-20"></th>
                    <th pSortableColumn="printedName">Printed Name
                        <p-sortIcon field="printedName"></p-sortIcon>
                    </th>

                    <th pSortableColumn="es2Key">
                        ES2Key
                        <p-sortIcon field="es2Key"></p-sortIcon>
                    </th>
                    <th pSortableColumn="fieldOfUse">Field of Use
                        <p-sortIcon field="fieldOfUse"></p-sortIcon>
                    </th>
                    <th pSortableColumn="type">Type
                        <p-sortIcon field="type"></p-sortIcon>
                    </th>
                    <th pSortableColumn="category">Category
                        <p-sortIcon field="category"></p-sortIcon>
                    </th>
                    <th pSortableColumn="state">State
                        <p-sortIcon field="state"></p-sortIcon>
                    </th>
                    <th pSortableColumn="lastActivity">Last Activity
                        <p-sortIcon field="lastActivity"></p-sortIcon>
                    </th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sample>
                <tr>
                    <td class="w-20 min-w-20"><img
                            [src]="sample?.media?.content?.preview?.cloudfrontUrl || 'assets/images/no-image.png'"
                            alt="Sample Image"
                            class="w-10 h-10 min-w-10 shrink-0 object-cover rounded-sm"></td>
                    <td>
                        <div>{{ sample.printedName }}</div>
                        <div class="text-sm text-gray-500 dark:text-gray-400">
                            {{ sample.detailNames || '' }}
                        </div>
                    </td>
                    <td>{{ sample.es2Key }}</td>
                    <td>
                        <p-tag
                                [value]="sample.fieldOfUse"
                                [severity]="sample.fieldOfUse | fieldOfUseSeverity"
                        ></p-tag>
                    </td>
                    <td>
                        <p-tag
                                [value]="sample.type.name"
                                severity="secondary"
                        ></p-tag>
                    </td>
                    <td>
                        <p-tag
                                [value]="sample.category?.name ?? 'No category'"
                                severity="secondary"
                        ></p-tag>
                    </td>

                    <td>
                        <p-tag
                                [value]="sample.onHold ? (sample.state | enumLabel) + ' (On Hold)' : (sample.state | enumLabel)"
                                [severity]="sample.onHold ? 'warn' : (sample.state | sampleStateSeverity)"
                        ></p-tag>
                    </td>
                    <td>{{ sample.lastActivity | formatDateTime }}</td>
                    <td>
                        <div class="flex justify-end items-center">
                            <p-button icon="pi pi-eye"
                                      text
                                      pTooltip="View sample"
                                      tooltipPosition="left"
                                      (click)="viewSample(sample)"></p-button>
                            <p-button icon="pi pi-pencil"
                                      isMaintainer
                                      text
                                      pTooltip="Edit sample"
                                      tooltipPosition="left"
                                      (click)="editSample(sample)"></p-button>
                            <p-button icon="pi pi-trash"
                                      isMaintainer
                                      text
                                      severity="danger"
                                      pTooltip="Delete sample"
                                      tooltipPosition="left"
                                      [disabled]="sample.state === SampleState.ACTIVE || sample.state === SampleState.ARCHIVED"
                                      (click)="deleteSample(sample)"></p-button>
                            <p-menu #rowMenu [popup]="true" [model]="rowActionItems" appendTo="body"></p-menu>
                            <p-button icon="pi pi-ellipsis-v"
                                      severity="secondary"
                                      text
                                      rounded
                                      pTooltip="Actions"
                                      tooltipPosition="left"
                                      (click)="openRowActionsMenu($event, rowMenu, sample)"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </div>
</div>
<div class="mb-6">
    <div class="mb-2">
        <h2 class="text-2xl text-gray-800 dark:text-gray-100 font-semibold mb-1">The Sample process flow</h2>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">The diagram below shows the process flow of a sample in
            the
            system. Samples with no valid vehicle model are archived automatically
        </p>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <app-sample-process></app-sample-process>
    </div>
</div>
<div class="mb-6 flex gap-2">
    <p-button label="Export all Samples" icon="pi pi-download" (click)="this.exportSamples()"
              severity="secondary"></p-button>
    <p-button label="Export all SampleLanguages" icon="pi pi-download" (click)="this.exportSampleLanguages()"
              severity="secondary"></p-button>
    @if (canSeeVehicleModels()) {
        <p-button label="Export all SampleVehicleModels" icon="pi pi-download"
                  (click)="this.exportSampleVehicleModels()" severity="secondary"></p-button>
        <p-button label="Custom Sample Export" icon="pi pi-download"
                  (click)="this.openCustomExportDialog()" severity="secondary"></p-button>
    }
</div>


<app-create-sample-dialog
        [(visible)]="this.displayCreateSampleDialog"
        [toCopy]="this.sampleToCopy"
        (sampleCreated)="loadSamples()"
></app-create-sample-dialog>

<app-update-sample-dialog
        [(visible)]="this.displayUpdateSampleDialog"
        [sample]="this.selectedSample"
        (sampleUpdated)="loadSamples()"></app-update-sample-dialog>

<app-filter-samples-dialog
        [(visible)]="filterDialogVisible"
        [fieldOfUseOptions]="fieldOfUseOptions"
        [sampleTypeOptions]="sampleTypeOptions"
        [sampleStateOptions]="sampleStateOptions"
        [sampleCategoryOptions]="sampleCategoryOptions"
        [sampleDetailOptions]="sampleDetailsOptions"
        [sampleFormatOptions]="sampleFormatOptions"
        [activeFilters]="{
            fieldOfUse: selectedFieldsOfUse,
            sampleType: selectedSampleTypes,
            sampleState: selectedSampleStates,
            sampleCategory: selectedSampleCategories,
            sampleDetails: selectedSampleDetails,
            format: selectedFormats
        }"
        (filtersApplied)="onFiltersApplied($event)"
></app-filter-samples-dialog>

<app-change-sample-state-dialog
        [(visible)]="displayChangeStateDialog"
        [header]="changeStateDialogHeader"
        [message]="changeStateDialogMessage"
        [sampleId]="changeStateDialogSampleId"
        [newSampleState]="changeStateDialogNewSampleState"
        (sampleStateChange)="loadSamples()">
</app-change-sample-state-dialog>

<app-toggle-on-hold-dialog
        [(visible)]="showOnHoldDialog"
        [sample]="this.selectedSampleObject"
        (toggled)="loadSamples()"
/>

<app-custom-export-dialog
        [(visible)]="displayCustomExportDialog"
        [fieldOfUseOptions]="fieldOfUseOptions"
        [sampleTypeOptions]="sampleTypeOptions"
        [sampleStateOptions]="sampleStateOptions"
        [sampleCategoryOptions]="sampleCategoryOptions"
        [sampleDetailOptions]="sampleDetailsOptions"
        [sampleFormatOptions]="sampleFormatOptions"
        [brandOptions]="brandOptions"
        [bodyTypeOptions]="bodyTypeOptions"
        [carClassOptions]="carClassOptions"
        (exportConfirmed)="onCustomExport($event)">
</app-custom-export-dialog>
